export default __webpack_public_path__ + "static/media/marginal-efficiency.721ef9d7.png";